import fetch from '@/api/fetch';

const path = process.env.VUE_APP_BASE_SERVER_URL;
export const allinPayBalanceSearchApi = req =>
  fetch({
    url: path + '/allin/pay/balance/search',
    method: 'get',
    params: req
  });

export const allinPayBanksApi = req =>
  fetch({
    url: path + '/allin/pay/banks',
    method: 'get',
    params:req
  });

export const allinPayDrawApplyApi = req =>
  fetch({
    url: path + '/allin/pay/draw/apply',
    method: 'post',
    data: req,
  });

export const allinPayDrawPageListApi = req =>
  fetch({
    url: path + '/allin/pay/draw/page/list',
    method: 'post',
    data: req,
  });
 
export const getAccounts = req =>
  fetch({
    url:path+'/allin/pay/current/receivers',
    method:'get',
    data:req
  })